import { Component, OnInit } from '@angular/core';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LiftModuleService } from '../../services/lift-module.service';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { NotificationType } from 'src/app/core/models/ui-notification.model';

@Component({
  selector: 'app-create-lift-module',
  templateUrl: './create-lift-module.component.html',
  styleUrls: ['./create-lift-module.component.css']
})
export class CreateLiftModuleComponent implements OnInit {

  form = new FormGroup({});

  constructor(
    private liftModuleService: LiftModuleService,
    private entityListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService
  ) {

  }

  ngOnInit() {
    this.form.addControl('code', new FormControl('', Validators.required));
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {
    if (this.form.valid) {
      this.liftModuleService.create({
        code: this.form.get('code').value
      }).subscribe(() => {
        this.entityListRefresh.refresh('lift-module');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Modul byl přidán'
        });
        modal.closeModal(null);
      });
    }
  }

}
